export default "__VITE_ASSET__DoqgULEt__"